export default "__VITE_ASSET__ff8d4cb3__"